import { RegistrationFormScreens } from "app/utils/const";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
type NextStepButtonProps = {
  setSelectedScreen: (selectedScreen: string) => void;
  usernameValidated: boolean;
  emailValidated: boolean;
  passwordValidated: boolean;
};

const NextStepButton = ({
  usernameValidated,
  emailValidated,
  passwordValidated,
  setSelectedScreen,
}: NextStepButtonProps) => {
  const [disableContinueButton, setDisableContinueButton] = useState(true);

  useEffect(() => {
    setDisableContinueButton(
      !(usernameValidated && emailValidated && passwordValidated)
    );
  }, [usernameValidated, emailValidated, passwordValidated]);

  return (
    <div className="continue-button-container">
      <button
        className="nav-bar__nav-item--contact nav-bar__nav-item--contact--button"
        disabled={disableContinueButton}
        onClick={() =>
          setSelectedScreen(RegistrationFormScreens.PERSONAL_DETAILS)
        }
      >
        <FormattedMessage tagName="div" id="home-register-continue" />
      </button>
    </div>
  );
};

export default NextStepButton;
